import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {StatementsComponent} from './web/statements/Statement/statements.component';
import {StatementsParentComponent} from './web/statements/StatementParent/statements-parent.component';
import {StatementsInvoicesComponent} from './web/statements/StatementInvoice/statements-invoices.component';
import {StatementsStoresComponent} from './web/statements/StatementStores/statement-stores.component';
import {InvoicesComponent} from './web/invoices/Invoices/invoices.component';
import {InvoicesParentsComponent} from './web/invoices/InvoicesParent/invoices-parents.component';
import {InvoicesStoresComponent} from './web/invoices/InvoicesStores/invoices-stores.component';
import {InvoicesInvoicesComponent} from './web/invoices/InvoicesInvoices/invoices-invoices.component';
import {GLGuideMenuComponent} from './web/glguide/glguidemenu.component';
import {GLMaintainItemComponent} from './web/glguide/glmaintainitem/glmaintainitem.component';
import {ReportAccessComponent} from "~/app/web/user-admin/components/report-access/report-access.component";
import {StoreAccessComponent} from "~/app/web/user-admin/components/store-access/store-access.component";
import {PicklistFormComponent} from "~/app/web/shared/picklist-form/picklist-form.component";
import {InvoiceLookupComponent} from "~/app/web/Invoice-lookup/invoice-lookup.component";
import {LogoutComponent} from './web/logout/logout.component';
import {Globals} from './core/shared/globals';
import {MessagesComponent} from './web/common/messages/messages.component';
import {LookupStatementsComponent} from './web/statements/QuickLookup/lookup.component';
import {MenuComponent} from './web/menu/menu.component';
import {MatMenuModule} from '@angular/material/menu';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {KendoMessageDialogComponent} from './web/common/kendo-message-dialog/kendo-message-dialog.component';
import {KendoYesNoDialogComponent} from './web/common/kendo-yes-no-dialog/kendo-yes-no-dialog.component';
import {KendoConfirmationDialogComponent} from './web/common/kendo-confirmation-dialog/kendo-confirmation-dialog.component';
import {DateInputModule, DateInputsModule, DatePickerModule, DateRangeModule} from '@progress/kendo-angular-dateinputs';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ListViewModule} from "@progress/kendo-angular-listview";
import {
  AuthInit, AuthInterceptorService,
  ChallengeGuard,
  ChallengeModule,
  CookieManagementService,
  JwtService,
  MclaneWebauthLibModule,
  OauthService,
  WEBAUTHENVIRONMENTER
} from 'mclane-webauth-lib';
import {ApptemplateLibModule, ENVIRONMENTERTEMPLATE, LoggingService} from 'mclane-apptemplate-lib';
import {environment} from '../environments/environment';
import {HomeComponent} from './web/Home/home.component';
import {MatButtonModule} from '@angular/material/button';
import {ButtonModule, ButtonsModule} from '@progress/kendo-angular-buttons';
import {DialogModule,DialogsModule, WindowModule} from '@progress/kendo-angular-dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatInputModule} from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import {
  BodyModule,
  ColumnResizingService,
  ExcelModule,
  GridModule,
  HeaderModule,
  PDFModule,
  RowFilterModule
} from '@progress/kendo-angular-grid';
import {RestService} from './core/shared/services/rest.service';
import {DateService} from './core/shared/services/date.service';
import {CommonModule, DatePipe} from '@angular/common';
import {MenuModule} from '@progress/kendo-angular-menu';
import {GLCodeMaintenanceComponent} from './web/glguide/glcodemaintenance/glcodemaintenance.component';
import {GLReviewGuideComponent} from './web/glguide/glreviewguide/glreviewguide.component';
import {GLGuideAuditComponent} from './web/glguide/glguideaudit/glguideaudit.component';
import {AuthGuardService} from './core/guards/auth-guard.service';
import {RoleGuardService} from './core/guards/role-guard.service';
import {NotFoundComponent} from './web/not-found/not-found.component';
import {NoAccessComponent} from './web/not-found/no-access.component';
import {Error500Component} from './web/not-found/error-500.component';
import {ComboBoxModule, DropDownListModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {InputsModule, TextBoxModule} from '@progress/kendo-angular-inputs';
import {GlguideService} from './core/services/glguide.service';
import {IntlModule} from '@progress/kendo-angular-intl';
import {RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service} from 'ng-recaptcha-2';
import {CookieService} from 'ngx-cookie-service';
import {NoCommaPipe} from './core/pipe/no-comma.pipe';
import {GlobalErrorHandlerService} from './core/services/globalErrorHandlerService';
import {InvoiceProcessingComponent} from './web/accounting/accounts-payable/invoice-processing/invoice-processing.component';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {ItemsPostingComponent} from './web/accounting/accounts-payable/items-posting/items-posting.component';
import {InvoiceProcessingService} from './core/services/invoice-processing.service';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {ExportDialogComponent} from './web/export-dialog/export-dialog.component';
import {DownloadDialogComponent} from '~/app/web/invoices/downloadDialog/download-dialog.component';
import {DropDownListFilterComponent} from '~/app/core/filters/drop-down/drop-down-list-filter.component';
import {DateRangeFilterCellComponent} from '~/app/core/filters/date-range-cell/date-range-cell-filter.component';
import {ItemGlSetupComponent} from './web/setup/item-gl-setup/item-gl-setup.component';
import {TooltipModule} from '@progress/kendo-angular-tooltip';
import {ItemGlDetailsComponent} from './web/setup/item-gl-details/item-gl-details.component';
import {AddNewGlSetupComponent} from './web/accounting/accounts-payable/add-new-gl-setup/add-new-gl-setup.component';
import {NotificationModule} from '@progress/kendo-angular-notification';
import {EditService} from '~/app/core/services/edit.service';
import {StoreApGlXrefComponent} from './web/setup/store-ap-gl-xref/store-ap-gl-xref.component';
import {ItemSetupComponent} from './web/setup/item-setup/item-setup.component';
import {ItemDetailsComponent} from './web/setup/item-details/item-details.component';
import {StoreConfigComponent} from './web/setup/store-config/store-config.component';
import {StoreReportGroupingComponent} from "~/app/web/setup/store-report-grouping/store-report-grouping.component";
import {FloatingLabelModule, LabelModule} from '@progress/kendo-angular-label';
import {AddSegmentComponent} from './web/setup/store-config/add-segment/add-segment.component';
import {GlCodesSetupTemplateComponent} from './web/setup/gl-codes-setup-template/gl-codes-setup-template.component';
import {PreviewTemplateCopyComponent} from './web/setup/gl-codes-setup-template/preview-template-copy/preview-template-copy.component';
import {TemplateCopyService} from '~/app/core/services/template-copy.service';
import {TreeViewModule} from '@progress/kendo-angular-treeview';
import {HierarchyComponent} from '~/app/web/setup/hierarchy/components/hierarchy.component';
import {HierarchyContainerComponent} from '~/app/web/setup/hierarchy/containers/hierarchy.container';
import {ReportsComponent} from './web/reports/reports.component';
import {DynamicFormComponent} from '~/app/web/shared/dynamic-form/dynamic-form.component';
import {ChainSelectComponent} from '~/app/web/shared/chain-select/chain-select.component';
import {DateRangeComponent} from '~/app/web/shared/date-range/date-range.component';
import {HierarchyBottomComponent} from './web/setup/hierarchy/components/hierarchy-bottom/hierarchy-bottom.component';
import {ReportsExtractComponent} from '~/app/web/shared/reports-extract/reports-extract.component';
import {ToastrModule} from 'ngx-toastr';
import {ToastService} from '~/app/core/services/toast-service';
import {PopupModule} from '@progress/kendo-angular-popup';
import {RetryInterceptorService} from "~/app/core/interceptors/retry-interceptor.service";
import {BaseService} from "~/app/core/services/base.service";
import { ICON_SETTINGS, IconsModule } from "@progress/kendo-angular-icons";
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { provideFeatureToggles } from './core/services/featuretoggle.provider';
import { FeatureToggleDirective } from './core/directives/featuretoggle.directive';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
declare let gtag: Function;
export function
AuthFactory(keycloakService: KeycloakService, authInit: AuthInit,
            jwtService: JwtService, cookieMan: CookieManagementService, console: LoggingService) {

  return async () => {
    return await keycloakService.init({
      config: environment.keycloak,
      loadUserProfileAtStartUp: true,
      initOptions: {onLoad: 'login-required', checkLoginIframe: false},
    }).then(async () => {
      await keycloakService.getToken().then(async (token) => {
        jwtService.setJwt(token);
        gtag('set', {'user_id': jwtService.preferred_username});
        console.log('preferred username= ', jwtService.preferred_username);
        console.log('roles= ', jwtService.roles);
      });
    });
  };
}

const containers = [
  HierarchyContainerComponent
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StatementsComponent,
    StatementsParentComponent,
    StatementsInvoicesComponent,
    StatementsStoresComponent,
    InvoicesComponent,
    InvoicesStoresComponent,
    InvoicesInvoicesComponent,
    InvoicesParentsComponent, // Deprecated, here for compilation
    InvoiceLookupComponent,
    GLGuideMenuComponent,
    GLCodeMaintenanceComponent,
    GLMaintainItemComponent,
    GLReviewGuideComponent,
    GLGuideAuditComponent,
    PicklistFormComponent,
    ReportAccessComponent,
    StoreAccessComponent,
    StoreReportGroupingComponent,
    LogoutComponent,
    LookupStatementsComponent,
    MenuComponent,
    MessagesComponent,
    KendoMessageDialogComponent,
    KendoConfirmationDialogComponent,
    NotFoundComponent,
    NoAccessComponent,
    Error500Component,
    KendoYesNoDialogComponent,
    NoCommaPipe,
    InvoiceProcessingComponent,
    ItemsPostingComponent,
    ExportDialogComponent,
    DownloadDialogComponent,
    DropDownListFilterComponent,
    DateRangeFilterCellComponent,
    ItemGlSetupComponent,
    ItemGlDetailsComponent,
    AddNewGlSetupComponent,
    StoreApGlXrefComponent,
    ItemSetupComponent,
    ItemDetailsComponent,
    StoreConfigComponent,
    AddSegmentComponent,
    GlCodesSetupTemplateComponent,
    PreviewTemplateCopyComponent,
    HierarchyComponent,
    ReportsComponent,
    DynamicFormComponent,
    ChainSelectComponent,
    ChainSelectComponent,
    DateRangeComponent,
    ReportsExtractComponent,
    HierarchyBottomComponent,
    FeatureToggleDirective,
    containers,
  ],
  // entryComponents: [
  //   KendoMessageDialogComponent,
  //   KendoConfirmationDialogComponent,
  //   KendoYesNoDialogComponent,
  //   ExportDialogComponent,
  //   DownloadDialogComponent,
  //   AddNewGlSetupComponent,
  //   ItemDetailsComponent,
  //   AddSegmentComponent,
  //   PreviewTemplateCopyComponent,
  //   InvoiceLookupComponent
  // ],
  imports: [
    ToastrModule.forRoot({
      timeOut: 5000,
      autoDismiss: true,
      maxOpened: 5,
      positionClass: 'toast-bottom-right',
      progressAnimation: 'decreasing',
      progressBar: true
    }),
    RecaptchaModule,
    RecaptchaFormsModule,
    BrowserModule,
    MatProgressBarModule,
    BrowserAnimationsModule,
    TreeViewModule,
    FloatingLabelModule,
    TooltipModule,
    AppRoutingModule,
    ApptemplateLibModule,
    KeycloakAngularModule,
    MatButtonModule,
    MatIconModule,
    IconsModule,
    MatMenuModule,
    ButtonModule,
    DatePickerModule,
    DateInputsModule,
    DialogModule,
    MatCheckboxModule,
    MatRadioModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    HeaderModule,
    WindowModule,
    IndicatorsModule,
    DialogsModule,
    ButtonsModule,
    MenuModule,
    MatTabsModule,
    DropDownListModule,
    ListViewModule,
    LayoutModule,
    TextBoxModule,
    BodyModule,
    IntlModule,
    ChallengeModule,
    MclaneWebauthLibModule,
    ApptemplateLibModule,
    FlexLayoutModule,
    RowFilterModule,
    DateRangeModule,
    DateInputModule,
    NotificationModule,
    InputsModule,
    CommonModule,
    LabelModule,
    PDFModule,
    ExcelModule,
    ComboBoxModule,
    PopupModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: RetryInterceptorService, multi: true},
    CookieService,
    ReCaptchaV3Service,
    OauthService,
    {
      deps: [BaseService],
      provide: EditService,
      useFactory: (jsonp: BaseService) => () => new EditService(jsonp)
    },
    {
      provide: APP_INITIALIZER,
      useFactory: AuthFactory,
      multi: true,
      deps: [KeycloakService, AuthInit, JwtService, CookieManagementService, LoggingService]
    },
    {provide: ENVIRONMENTERTEMPLATE, useValue: environment},
    {provide: WEBAUTHENVIRONMENTER, useValue: environment},
    {provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Lchb6MZAAAAAKm5BjabNHPTJDq9CorYDIBYkgyW'},
    { provide: ICON_SETTINGS, useValue: { type: 'svg' } },
    DatePipe,
    Globals,
    RestService,
    DateService,
    JwtService,
    AuthGuardService,
    RoleGuardService,
    GlguideService,
    TemplateCopyService,
    ColumnResizingService,
    LoggingService,
    InvoiceProcessingService,
    LocalStorageIndexedService,
    ToastService,
    provideFeatureToggles(),
    {provide: ErrorHandler, useClass: GlobalErrorHandlerService},
    provideHttpClient(withInterceptorsFromDi(), withFetch())
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
